import React from 'react';

const BackButton = ({ onClick, title = "Back", className = "" }) => {
    if (!onClick) return null;

    return (
        <button
            onClick={onClick}
            className={`w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-primary transition-all hover:shadow-md ${className}`}
            title={title}
        >
            <span className="material-symbols-outlined !text-[24px]">arrow_back</span>
        </button>
    );
};

export default BackButton;
